import React, { Component } from 'react';
import EncontrosDefault from './encontrosDefault';
import API from '../../comm/API';
import { getByKeyOrEmpty, mapAtendimentoNome, viewDataModels } from './mentoriaUtilDigital';
import AtividadeDefaultDigital from './atividadeDefaultDigital';
import AtividadeMaisInfo from './atividadeMaisInfo';
import AtividadeDocumentacaoFinal from './atividadeDocumentaoFinal';
import AtividadeAvaliacaoDoAtendimento from './atividadeAvaliacaoDoAtendimento';
import AtividadeResultadoGeral from './atividadeResultadoGeral';
import AtendimentosCardDigital from './atendimentosCardDigital';

export default class ConsultoriaD extends Component {

    STATUS_FINALIZADO = 3;
    STATUS_CONTINUO = 4;
    renderOptions = {
        ATENDIMENTO: 'atendimento',
        VISITAS: 'encontros'
    };

    constructor(props) {
        super(props);
        const etapaName = `etapaConsultoria${this.props.fase}`;
        const etapa = this.props.turma[etapaName];
        this.viewData = JSON.parse(JSON.stringify(viewDataModels[etapaName]));
        this.viewData.turma = this.props.turma.nome;
        this.viewData.etapa.etapaFinalizada = etapa.finalizada;
        this.viewData.etapa.nome = 'Consultoria D';
        const atendimentoList = mapAtendimentoNome(etapa, this.props.turma);

        this.state = {
            turma: this.props.turma,
            renderTo: this.renderOptions.ATENDIMENTO,
            viewData: this.viewData,
            atendimentoConsultoria: undefined,
            etapa,
            atendimentoList,
            clientName: '',
            disabled: false
        };
    };

    getResultadoModel = () => {
        return {
            status: 1, 
            ordemVisita: null, 
            assinaturas: []
        };
    }

    getDocumentacaoDigitalModel = () => {
        return { 
            status: 1, 
            ordemVisita: null, 
            anexoDocumentacaoList: [], 
            maisInfo: ""
        };;
    }

    getAvaliacaoDigitalModel = () => {
        return {
            status: 1,
            ordemVisita: null, 
            pontuacaoAtendimento: 0,
            pontuacaoCapacidadeTeorica: 0,
            pontuacaoAplicacaoMetodologia: 0,
            pontuacaoTempoExecucaoMetodologia: 0,
            pontuacaoCustoProduto: 0,
            pontuacaoResultados: 0,
            pontuacaoExpectativas: 0,
            pontuacaoResultadosMantidos: 0
        };
    }

    getModels = () => {
        return {
          resultado: this.getResultadoModel(),
          documentacaoDigital: this.getDocumentacaoDigitalModel(),
          avaliacaoDigital: this.getAvaliacaoDigitalModel(),
        }
    }

    updateViewData = (atendimento) => {

        this.viewData.encontros.data = atendimento.encontroList;
        const { documentacaoDigital, avaliacaoDigital, resultado } = atendimento; 

        this.setState({disabled: this.state.turma.status === 3})

        this.viewData.atividades.documentacaoDigital.data =  JSON.parse(JSON.stringify(documentacaoDigital || this.getDocumentacaoDigitalModel()));
        this.viewData.atividades.documentacaoDigital.anexos.data = getByKeyOrEmpty(documentacaoDigital, 'anexoDocumentacaoList');

        this.viewData.atividades.avaliacaoDigital.data =  JSON.parse(JSON.stringify(avaliacaoDigital || this.getAvaliacaoDigitalModel()));

        this.viewData.atividades.avaliacaoDigital.disabled =  avaliacaoDigital && avaliacaoDigital.status === 3;

        this.viewData.atividades.resultado.data =  JSON.parse(JSON.stringify(resultado || this.getResultadoModel()));
        this.viewData.atividades.resultado.anexos.data = getByKeyOrEmpty(resultado, 'assinaturas');

    };

    validateAtendimentoConsultoria = async (atendimentoConsultoria) => {  
        let encontroList = atendimentoConsultoria.encontroList;

        if (!atendimentoConsultoria.cancelado) {
            return await encontroList && encontroList.length > 0 && encontroList.every(encontro => { return this.validaEncontro(encontro) }); 
        }
        return true;        
    };

    validaEncontro = (encontro) => {
        return encontro && encontro.anexoEncontroList && encontro.anexoEncontroList.length > 0 && !encontro.anexoEncontroList.filter(anx => { return !anx.isDocumento }).some(anx => { return anx.descricao === '' }) &&
        encontro.data && encontro.isVirtual != null && encontro.turno != null && encontro.idMentor != null && encontro.horasApropriadas > 0;
    };

    // TODO: Verificar finalizar turma
    handleFinishMentoriaAtendimento = async () => {
        let atendimentoConsultoria = this.state.atendimentoConsultoria;
        let turma = this.props.turma;
        let validado = await this.validateAtendimentoConsultoria(atendimentoConsultoria);

        const errorFinish = (error) => {
            this.props.closeLoading();
            this.props.showToast('Error ao tentar finalizar etapa. Favor, entrar em contato com o suporte.', 'error');
            throw new Error(error);
        }


        if (validado) {
            this.props.showLoading();
            atendimentoConsultoria.finalizado = true;
            let indexAtendimento = turma.etapaConsultoriaC.atendimentoList.findIndex(obj => { return obj.id === atendimentoConsultoria.id });
            turma.etapaConsultoriaD.atendimentoList[indexAtendimento] = atendimentoConsultoria; //atualiza atendimentoConsultoria na etapa pratica b da turma
            let etapa = turma.etapaConsultoriaD;
            let i, count = 0;
            for (i = 0; i < etapa.atendimentoList.length; i++) {           
                if (!etapa.atendimentoList[i].finalizado && !etapa.atendimentoList[i].cancelado) break;
                count++;
            }
            if (count === etapa.atendimentoList.length) { //save + finalizar etapa
                etapa.finalizada = true;
                turma.status = this.STATUS_FINALIZADO;
                try {
                    this.props.showLoading();
                    await this.props.saveTurma(turma);
                    this.props.showToast('Etapa finalizada com sucesso!', 'success');
                    this.props.goBack();
                } catch(error) {
                    this.props.showToast('Error ao tentar finalizar a etapa. Favor, entrar em contato com o suporte.', 'error');
                }
            } else { //save
                etapa = this.state.etapa;
                return await API.post('rest/gestao/TurmaMentoriaDigital/' + turma.id, turma).then(() => {
                    return API.get('rest/gestao/TurmaMentoriaDigital/' + turma.id).then(async res => {
                        turma = res.data;
                        etapa = turma.etapaConsultoriaD;
                        let atendimentoList = mapAtendimentoNome(etapa, turma);
                        let index = etapa.atendimentoList.findIndex(obj => { return obj.id === atendimentoConsultoria.id });
                        let atd = etapa.atendimentoList[index];
                        await this.updateViewData(atd);
                        this.props.closeLoading();
                        this.setState({ turma, etapa, atendimentoList, atendimentoConsultoria: atd }, this.goBackAtendimentos());
                        this.props.showToast('Etapa finalizada com sucesso!', 'success');
                    }).catch(error => { errorFinish(error); });
                }).catch(error => { errorFinish(error); });
            }
        } else {
            this.props.showToast('Há informações/atividade(s) pendente(s) nos encontros dessa etapa.', 'error');
            return;
        }
    };

    validateResultadoDigital(resultadoDigital){
        return resultadoDigital.assinaturas && resultadoDigital.assinaturas.length === 2;
    }
    
    validateAvaliacaoDigital(avaliacaoDigital) {
        return avaliacaoDigital.pontuacaoAtendimento && avaliacaoDigital.pontuacaoCapacidadeTeorica && avaliacaoDigital.pontuacaoAplicacaoMetodologia && 
            avaliacaoDigital.pontuacaoTempoExecucaoMetodologia && avaliacaoDigital.pontuacaoCustoProduto && avaliacaoDigital.pontuacaoResultados &&
            avaliacaoDigital.pontuacaoExpectativas && avaliacaoDigital.pontuacaoResultadosMantidos;
    }

    validateDocumentacaoDigital(documentacaoDigital) {
        return !!documentacaoDigital.anexoDocumentacaoList.length && documentacaoDigital.anexoDocumentacaoList.every(elm => { return elm.descricao });
    }


    validaAtividade = async (viewData, atendimentoConsultoria, currScreenAtividade, nomeAtividade, nomeAnexo, funcaoValidacaoAtividade, status) => {
        let atividade = viewData.selected.atividade.data;
        atividade.ordemVisita = atendimentoConsultoria[nomeAtividade] ? atendimentoConsultoria[nomeAtividade].ordemVisita : viewData.selected.visita.ordem; 
        if (nomeAnexo) {
            atividade[nomeAnexo] = viewData.selected.atividade.anexos.data;
        } 
        let validate = funcaoValidacaoAtividade(atividade);

        if(this.state.etapa.finalizada){
            if (!validate) {
                this.props.showToast('Há informações pendentes nessa atividade.', 'error');
                throw new Error();
            } else {
                atividade.status = status;
            }
        }
        else{
            if (!validate) {
                atividade.status = 2;
            } else {
                atividade.status = status;
            }
        }
        atendimentoConsultoria[nomeAtividade] = atividade;
    };

    
    saveEtapa = async (viewData, rmVisita) => {
        let etapa = this.state.etapa;
        let turma = this.props.turma;
        let atendimentoConsultoria = this.state.atendimentoConsultoria;
        let encontrosData = viewData.encontros.data;
        let selectedVisita = viewData.selected.visita;
        let currScreenAtividade;
        
        let hasError = false;

        if (!rmVisita) {
            if (viewData.selected.atividade) currScreenAtividade = viewData.selected.atividade.screenAtividade;

            if (currScreenAtividade === 'documentacaoDigital') 
                this.validaAtividade(viewData, atendimentoConsultoria, currScreenAtividade, 'documentacaoDigital', null, this.validateDocumentacaoDigital, this.STATUS_FINALIZADO);
            else if (currScreenAtividade === 'avaliacaoDigital') {
                this.validaAtividade(viewData, atendimentoConsultoria, currScreenAtividade, 'avaliacaoDigital', null, this.validateAvaliacaoDigital, this.STATUS_FINALIZADO);
            } else if (currScreenAtividade === 'resultado') {
                this.validaAtividade(viewData, atendimentoConsultoria, currScreenAtividade, 'resultado', null, this.validateResultadoDigital, this.STATUS_FINALIZADO);
            }
            
            if (selectedVisita) {
                selectedVisita.anexoEncontroList = [];
                selectedVisita.anexoEncontroList = selectedVisita.anexoEncontroList.concat(selectedVisita.relatorios != null ? selectedVisita.relatorios : []);
                selectedVisita.anexoEncontroList = selectedVisita.anexoEncontroList.concat(selectedVisita.listaPresenca != null ? selectedVisita.listaPresenca : []);
                selectedVisita.anexoEncontroList = selectedVisita.anexoEncontroList.concat(selectedVisita.outrosDocumentos != null ? selectedVisita.outrosDocumentos : []);
                selectedVisita.anexoEncontroList = selectedVisita.anexoEncontroList.concat(selectedVisita.imagens != null ? selectedVisita.imagens : []);
                if (selectedVisita.id && !currScreenAtividade) {
                    if ((this.state.etapa.finalizada && !this.validaEncontro(selectedVisita))) {
                        this.props.showToast('Há informações pendentes nesse encontro.', 'error');
                        throw new Error();
                    }
                }
                let index = encontrosData.findIndex(aux => { return selectedVisita.ordem === aux.ordem });
                if (index > -1) atendimentoConsultoria.encontroList[index] = selectedVisita;
                else atendimentoConsultoria.encontroList.push(selectedVisita);
            }
            atendimentoConsultoria.horasApropriadas = atendimentoConsultoria.encontroList.reduce((a, b) => + a + + b.horasApropriadas, 0);
        }
        else {
            let atividades = viewData.atividades;
            let documentacaoDigital = atividades.documentacaoDigital;
            let avaliacaoDigital = atividades.avaliacaoDigital;
            let resultado = atividades.resultado;

            if ((!documentacaoDigital.data) || (documentacaoDigital.data  && !documentacaoDigital.data.ordemVisita)) atendimentoConsultoria.documentacaoDigital = null;
            if ((!avaliacaoDigital.data) || (avaliacaoDigital.data  && !avaliacaoDigital.data.ordemVisita)) atendimentoConsultoria.avaliacaoDigital = null;
            if ((!resultado.data) || (resultado.data  && !resultado.data.ordemVisita)) atendimentoConsultoria.resultado = null;
            atendimentoConsultoria.encontroList = encontrosData;
            atendimentoConsultoria.horasApropriadas = atendimentoConsultoria.encontroList.reduce((a, b) => + a + + b.horasApropriadas, 0);
        }
        let indexAtendimento = turma.etapaConsultoriaD.atendimentoList.findIndex(obj => { return obj.id === atendimentoConsultoria.id });
        turma.etapaConsultoriaD.atendimentoList[indexAtendimento] = atendimentoConsultoria; //atualiza atendimentoConsultoria na etapa pratica b da turma
        
        if(atendimentoConsultoria.horasApropriadas > 4){
            this.props.showToast('Não é permitido apropriar mais horas. Você atingiu o limite máximo de horas estabelecidas para esta etapa.', 'error');
            throw new Error();
        }
        
        else {if (!hasError) {
            return API.post('rest/gestao/TurmaMentoriaDigital/' + turma.id, turma).then(() => {
                return API.get('rest/gestao/TurmaMentoriaDigital/' + turma.id).then(async res => {
                    turma = res.data;
                    etapa = turma.etapaConsultoriaD;
                    let index = etapa.atendimentoList.findIndex(obj => { return obj.id === atendimentoConsultoria.id });
                    let atd = etapa.atendimentoList[index];
                    await this.updateViewData(atd);
                    this.setState({ turma, etapa, atendimentoConsultoria: atd });
                    this.props.showToast('Etapa editada com sucesso!', 'success');
                }).catch(error => {
                    this.props.showToast('Error ao tentar editar etapa. Favor, entrar em contato com o suporte.', 'error');
                    throw new Error(error);
                });
            }).catch(error => {
                this.props.showToast('Error ao tentar editar etapa. Favor, entrar em contato com o suporte.', 'error');
                throw new Error(error);
            });
        }}

       
    };

    renderAtividade = (selectedAtividade, reloadAtividade) => {
        let showEmptyEvidencias = false;
        let showTopButtons = true;
        let showAnexos = true;
        let render = null;

        if (!selectedAtividade.anexos.data) return;

        switch (selectedAtividade.screenAtividade) {
            case 'documentacaoDigital':
                render = <AtividadeDocumentacaoFinal 
                    atividade={selectedAtividade.data} 
                    showLoading={ this.props.showLoading } 
                    closeLoading={ this.props.closeLoading } 
                    showToast={ this.props.showToast } 
                    turma={ this.state.turma }
                    disabled={this.state.disabled} 
                />;
                showEmptyEvidencias = false;
                showTopButtons = false;
                showAnexos = false;
                break;
            case 'avaliacaoDigital':
                render = <AtividadeAvaliacaoDoAtendimento atividade={selectedAtividade.data} />;
                showEmptyEvidencias = false;
                showTopButtons = false;
                showAnexos = false;
                break;
            case 'resultado':
                render = <AtividadeResultadoGeral 
                    atividade={selectedAtividade.data} 
                    turma={ this.state.turma } 
                    atendimento={ this.state.atendimentoConsultoria }
                    showLoading={ this.props.showLoading } 
                    closeLoading={ this.props.closeLoading } 
                    showToast={ this.props.showToast } 
                    disabled={this.state.disabled}
                    usuarioConectado={ this.props.usuarioConectado }
                />;
                showEmptyEvidencias = false;
                showTopButtons = false;
                showAnexos = false;
                break;
            default:
                render = <AtividadeMaisInfo atividade={selectedAtividade.data} />
        }
        return (
            <AtividadeDefaultDigital
                turma={ this.state.turma }
                fase={ this.props.fase }
                showLoading={ this.props.showLoading }
                closeLoading={ this.props.closeLoading }
                showToast={ this.props.showToast }
                reloadAtividade={ reloadAtividade }
                title={ selectedAtividade.anexos.title }
                anexos={ selectedAtividade.anexos.data }
                defaultIcon={ selectedAtividade.anexos.defaultIcon }
                saveAtividades={ this.saveAtividades }
                showEmptyEvidencias={ showEmptyEvidencias }
                invertAnexos={true}
                showTopButtons={ showTopButtons }
                showAnexos={ showAnexos }
                renderChildren={ render }
                clientName={ this.state.clientName }
                viewData={ this.state.viewData } 
            />
        );
    };

    renderVisita = (atendimento) => {
        this.updateViewData(atendimento);
        this.setState({ renderTo: this.renderOptions.VISITAS, viewData: this.viewData, atendimentoConsultoria: atendimento, clientName: atendimento.clientName });
    };

    goBackAtendimentos = () => {
        this.setState({ renderTo: this.renderOptions.ATENDIMENTO, atendimentoConsultoria: undefined });
    };

    render() {
        return (<>
            { this.state.renderTo === this.renderOptions.ATENDIMENTO &&
                <AtendimentosCardDigital
                    turma={ this.state.turma }
                    fase={ this.props.fase }
                    title= { 'Consultoria' }
                    goBack={ this.props.goBack }
                    atendimentos={ this.state.atendimentoList }
                    renderVisita={ this.renderVisita } 
                />
            }
            { this.state.renderTo === this.renderOptions.VISITAS &&
                <EncontrosDefault
                    turma={ this.state.turma }
                    fase={ this.props.fase }
                    goBack={ this.props.goBack }
                    goBackAtendimentos={ this.goBackAtendimentos }
                    closeLoading={ this.props.closeLoading }
                    showLoading={ this.props.showLoading }
                    showToast={ this.props.showToast }
                    viewData={ this.state.viewData }
                    models={ this.getModels }
                    atendimento={ this.state.atendimentoConsultoria }
                    etapa = {this.state.etapa}
                    saveEtapa={ this.saveEtapa }
                    handleFinishMentoria={ this.handleFinishMentoriaAtendimento }
                    renderAtividade={ this.renderAtividade }
                    clientName={ this.state.clientName }
                    disabled={this.state.disabled}
                    dontShowFinalizarMentoria={ this.state.atendimentoConsultoria.finalizado }
                    mentoresDados={this.props.mentoresDados}
                />
            }
        </>)
    };
};